module.exports = __webpack_public_path__ + "static/media/22.97156700.mp3";